module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', {
    staticClass: "block block-themed block-bordered"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplaySectionApi === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayApi()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplaySectionApi) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayApi()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayApi()
      }
    }
  }, [_vm._v(_vm._s(_vm.sectionLabelApiManagement[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplaySectionApi) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header bg-gray"
  }, [_c('h3', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayDocument()
      }
    }
  }, [_vm._v(_vm._s(_vm.DocumentTableTitle[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplayDocument) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-vcenter"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.DocumentTableContain), function(Document) {
    return _c('tr', [_c('td', {
      staticClass: "font-w600"
    }, [_vm._v(_vm._s(Document.Document[_vm.actualLanguage]))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Document.Detail[_vm.actualLanguage]))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip",
        "title": "Ouvrir/Open"
      },
      on: {
        "click": function($event) {
          return _vm.openDocumentInTable(Document.FileLink[_vm.actualLanguage])
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-file-text"
    })])])])])
  }), 0)])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row push"
  }, [_c('h4', {
    staticClass: "font-w300"
  }, [_vm._v(_vm._s(_vm.descriptionStepSectionTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('h5', {
    staticClass: "font-w300"
  }, [_vm._v(_vm._s(_vm.descriptionStep01[_vm.actualLanguage]))]), _vm._v(" "), _c('h5', {
    staticClass: "font-w300"
  }, [_vm._v(_vm._s(_vm.descriptionStep01p1[_vm.actualLanguage]))]), _vm._v(" "), _c('h5', {
    staticClass: "font-w300"
  }, [_vm._v(_vm._s(_vm.descriptionStep02[_vm.actualLanguage]))]), _vm._v(" "), _c('h5', {
    staticClass: "font-w300"
  }, [_vm._v(_vm._s(_vm.descriptionStep03[_vm.actualLanguage]))]), _vm._v(" "), _c('h5', {
    staticClass: "font-w300"
  }, [_vm._v(_vm._s(_vm.descriptionStep04[_vm.actualLanguage]))]), _vm._v(" "), _c('h5', {
    staticClass: "font-w300"
  }, [_vm._v(_vm._s(_vm.descriptionStep05[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header bg-gray"
  }, [_c('h3', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayMasterApiKey()
      }
    }
  }, [_vm._v(_vm._s(_vm.sectionLabelCreateApiMasterKey[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplayMasterApiKey) ? _c('div', {
    staticClass: "block-content"
  }, [_c('h6', {
    staticClass: "push"
  }, [_vm._v(_vm._s(_vm.sectionTextCreateApiMasterKey[_vm.actualLanguage]))]), _vm._v(" "), (_vm.createNewApiMasterKey === false) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-center",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openCreateNewMasterKey()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelCreateApiMasterKey[_vm.actualLanguage]))])])])]) : _c('div', {
    staticClass: "row push"
  }, [_c('h3', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.sectionLabelCreateMasterApiKey[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.labelApiKeyReferenceName[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.referenceName),
      expression: "referenceName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Reference"
    },
    domProps: {
      "value": (_vm.referenceName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.referenceName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.labelTextBoxMaxCost[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.maximumMonthlyCost),
      expression: "maximumMonthlyCost"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Adresse / Address..."
    },
    domProps: {
      "value": (_vm.maximumMonthlyCost)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.maximumMonthlyCost = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group push"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-danger align-center",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.cancelCreateNewMasterKey()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelCancelCreateApiMasterKey[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-center",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createConfirmNewMasterKey()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelConfirmCreateApiMasterKey[_vm.actualLanguage]))])])])])])]), _vm._v(" "), (_vm.displayMasterAPIKeysListFlag) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('h4', {
    staticClass: "font-w300"
  }, [_vm._v(_vm._s(_vm.labelMasterKeyList[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.organizationApiKey), function(apiKey, index) {
    return _c('div', {
      staticClass: "block block-bordered"
    }, [_c('div', {
      staticClass: "block-header bg-gray-lighter"
    }, [_c('ul', {
      staticClass: "block-options"
    }, [_c('li', [_c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.toggleDisplayApiKey(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-key"
    })])])]), _vm._v(" "), (_vm.organizationApiKeyIsLoagingFlag[index]) ? _c('spinner', {
      attrs: {
        "size": "small"
      }
    }) : _c('h6', {
      on: {
        "click": function($event) {
          return _vm.toggleDisplayApiKey(index)
        }
      }
    }, [_vm._v(_vm._s(apiKey.referenceName) + "  :  " + _vm._s(apiKey.key))])], 1), _vm._v(" "), (_vm.organizationApiKeyOpenFlag[index]) ? _c('div', {
      staticClass: "block-content"
    }, [_c('div', {
      staticClass: "row push"
    }, [_c('div', {
      staticClass: "col-xs-12 col-md-12"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v("Date Émission/Emission date : " + _vm._s(_vm.organizationApiKeyData[index].emissionDate))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-md-12"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v("Statut/Status : " + _vm._s(_vm.organizationApiKeyData[index].status))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-md-4"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelTextBoxMaxCost[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.organizationApiKeyData[index].keyInfo.maximumMonthlyCost),
        expression: "organizationApiKeyData[index].keyInfo.maximumMonthlyCost"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Adresse / Address..."
      },
      domProps: {
        "value": (_vm.organizationApiKeyData[index].keyInfo.maximumMonthlyCost)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.organizationApiKeyData[index].keyInfo, "maximumMonthlyCost", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "row push"
    }, [_c('div', {
      staticClass: "col-sm-12 col-md-6"
    }, [_c('p', [_c('button', {
      staticClass: "btn btn-success align-center",
      attrs: {
        "type": "button",
        "name": "button"
      },
      on: {
        "click": function($event) {
          return _vm.modifyMasterKey()
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus fa-1x push-5-r "
    }), _vm._v("Enregistrer modifications / Save modifications")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6"
    }, [_c('p', [_c('button', {
      staticClass: "btn btn-danger align-center",
      attrs: {
        "type": "button",
        "name": "button"
      },
      on: {
        "click": function($event) {
          return _vm.deleteNewMasterKey()
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus fa-1x push-5-r "
    }), _vm._v("Supprimer la clef / Delete this key")])])]), _vm._v(" "), _vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-12 push"
    }, [_c('h3', {
      staticClass: "font-w300"
    }, [_vm._v(_vm._s(_vm.labelMasterKeyDeviceList[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.organizationApiKeyCreateDeviceFlag[index]) ? _c('div', {
      staticClass: "col-sm-12 col-md-12"
    }, [_c('div', {
      staticClass: "col-xs-12 col-md-6"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelCreateDeviceSerialNumber[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newDeviceSerialNumber),
        expression: "newDeviceSerialNumber"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Numero série / Sérial number"
      },
      domProps: {
        "value": (_vm.newDeviceSerialNumber)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.newDeviceSerialNumber = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-md-6 push"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelCreateDeviceTemplateToUse[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.newDeviceTemplateToUse),
        expression: "newDeviceTemplateToUse"
      }],
      staticClass: "form-control",
      attrs: {
        "size": "1"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.newDeviceTemplateToUse = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, _vm._l((_vm.deviceTemplates), function(Template) {
      return _c('option', {
        domProps: {
          "value": Template.deviceTemplateId
        }
      }, [_vm._v(_vm._s(Template.deviceTemplateId))])
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-md-12"
    }, [_c('div', {
      staticClass: "col-sm-12 col-md-6"
    }, [_c('p', [_c('button', {
      staticClass: "btn btn-success align-center",
      attrs: {
        "type": "button",
        "name": "button"
      },
      on: {
        "click": function($event) {
          return _vm.confirmCreateDevice(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus fa-1x push-5-r "
    }), _vm._v("Créer l'appareil / Create device")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6"
    }, [_c('p', [_c('button', {
      staticClass: "btn btn-danger align-center",
      attrs: {
        "type": "button",
        "name": "button"
      },
      on: {
        "click": function($event) {
          return _vm.cancelCreateDevice(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus fa-1x push-5-r "
    }), _vm._v("Annuler / Cancel")])])])])]) : _c('div', {
      staticClass: "col-sm-12 col-md-6"
    }, [_c('p', [_c('button', {
      staticClass: "btn btn-success align-center",
      attrs: {
        "type": "button",
        "name": "button"
      },
      on: {
        "click": function($event) {
          return _vm.createDevice(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus fa-1x push-5-r "
    }), _vm._v("Créer un appareil / Create device")])])]), _vm._v(" "), (_vm.lastCreatedDevice.deviceId.length > 0) ? _c('div', {
      staticClass: "col-xs-12 col-md-12"
    }, [_c('h4', {
      staticClass: "font-w300 push"
    }, [_vm._v("Appareil créé / Created device")]), _vm._v(" "), _c('h5', {
      staticClass: "font-w300"
    }, [_vm._v("Device ID: " + _vm._s(_vm.lastCreatedDevice.deviceId))]), _vm._v(" "), _c('h5', {
      staticClass: "font-w300"
    }, [_vm._v("Binding key: " + _vm._s(_vm.lastCreatedDevice.deviceBindingKey))]), _vm._v(" "), _c('h5', {
      staticClass: "font-w300"
    }, [_vm._v("API key: " + _vm._s(_vm.lastCreatedDevice.deviceApiKey))])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "row push"
    }, [_c('div', {
      staticClass: "col-xs-12 col-md-12"
    }, [_c('h4', [_vm._v(_vm._s(_vm.labelDeviceKeyList[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
      staticClass: "table-responsive"
    }, [_c('table', {
      staticClass: "table table-striped table-vcenter"
    }, [_vm._m(3, true), _vm._v(" "), _c('tbody', _vm._l((_vm.organizationApiKeySubKeyData[index]), function(SubKeyDetail, index) {
      return _c('tr', [_c('td', {
        staticClass: "font-w600"
      }, [_vm._v(_vm._s(SubKeyDetail.linkedEntity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(SubKeyDetail.info.bindingKey))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(SubKeyDetail.keyId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(SubKeyDetail.info.deviceSerialNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(SubKeyDetail.info.linkedProfile))])])
    }), 0)])])])])]) : _vm._e()])
  })], 2) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header bg-gray"
  }, [_c('h3', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplaySignalsSet()
      }
    }
  }, [_vm._v(_vm._s(_vm.SignalSetSectionTitle[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplaySectionSignalsSet) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row push"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-center",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createSignalsSet()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonSignalsSetCreate[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row push"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-vcenter"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "90%"
    }
  }, [_vm._v(_vm._s(_vm.tableLabelSignalsSetID[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.tableLabelSgnalsSetEdit[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.signalsSetTemplates), function(Template, index) {
    return _c('tr', [_c('td', {
      staticClass: "font-w600"
    }, [_vm._v(_vm._s(Template.signalSetId))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip",
        "title": "Modifier/Edit"
      },
      on: {
        "click": function($event) {
          return _vm.editSignalSetTemplate(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-gear"
    })])])])])
  }), 0)])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header bg-gray"
  }, [_c('h3', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayChannelTemplate()
      }
    }
  }, [_vm._v(_vm._s(_vm.ChannelTemplateSectionTitle[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplaySectionChannelTemplate) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row push"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-center",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createChannelTemplate()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonChannelTemplateCreate[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-4"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-center",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createNewPicture('channel')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonSaveNewPictureChannel[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row push"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-vcenter"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.tableLabelChannelTemplateID[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.tableLabelChannelTemplateName[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.tableLabelChannelTemplateType[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.tableLabelChannelTemplateEdit[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.channelTemplates), function(Template, index) {
    return _c('tr', [_c('td', {
      staticClass: "font-w600"
    }, [_vm._v(_vm._s(Template.channelTemplateId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Template.channelName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Template.channelType))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip",
        "title": "Modifier/Edit"
      },
      on: {
        "click": function($event) {
          return _vm.editChannelTemplate(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-gear"
    })])])])])
  }), 0)])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header bg-gray"
  }, [_c('h3', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayDeviceTemplate()
      }
    }
  }, [_vm._v(_vm._s(_vm.DeviceTemplateSectionTitle[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplaySectionDeviceTemplate) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row push"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-center",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createDeviceTemplate()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonDeviceTemplateCreate[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-center",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createNewPicture('device')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonSaveNewPictureDevice[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row push"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-vcenter"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.tableLabelChannelTemplateID[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.tableLabelChannelTemplateName[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.tableLabelChannelTemplateType[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v(_vm._s(_vm.tableLabelChannelTemplateEdit[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.deviceTemplates), function(Template, index) {
    return _c('tr', [_c('td', {
      staticClass: "font-w600"
    }, [_vm._v(_vm._s(Template.deviceTemplateId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Template.deviceName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Template.deviceType))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "type": "button",
        "data-toggle": "tooltip",
        "title": "Modifier/Edit"
      },
      on: {
        "click": function($event) {
          return _vm.editDeviceTemplate(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-gear"
    })])])])])
  }), 0)])])])]) : _vm._e()])])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("Document")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Document")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("Device ID")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Binding Key")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("API key")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("Serial Number")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("Binded to")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f3b83cbe","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/profile/OrganizationApiManagement.vue
// module id = 1593
// module chunks = 4